import common from './common.json';
import contactForm from './contact-form.json';

export default {
  common,
  contactForm,
};
